<form #userinfoAuthForm="ngForm">
  <div class="firstname fields">
    <app-input
      [type]="'text'"
      name="firstName"
      [formGroup]="userinfoAuthForm"
      [(ngModel)]="userProfile.fname"
      (ngModelChange)="userProfileChange.emit(userProfile)"
      label="First Name *"
      [placeholder]="'First Name'"
      (mouseleave)="trimName('fname')"
      required
      pattern="^([a-zA-Z]+(-[a-zA-Z]+)*(\s|$))+$"
      #firstName="ngModel"
    ></app-input>
  </div>
  <div class="lastname fields">
    <app-input
      [type]="'text'"
      name="lastName"
      [(ngModel)]="userProfile.lname"
      (ngModelChange)="userProfileChange.emit(userProfile)"
      [formGroup]="userinfoAuthForm"
      label="Last Name *"
      [placeholder]="'Last Name'"
      (mouseleave)="trimName('lname')"
      required
      pattern="^([a-zA-Z]+(-[a-zA-Z]+)*(\s|$))+$"
      #lastName="ngModel"
    ></app-input>
  </div>
  <div class="demographicInfo">
    <div class="ageField">
      <app-input
        [type]="'dropdown'"
        name="ageRange"
        [(ngModel)]="userProfile.ageRange"
        (ngModelChange)="userProfileChange.emit(userProfile)"
        [formGroup]="userinfoAuthForm"
        label="Age Range *"
        [placeholder]="'Age Range'"
        [options]="ageRangeOptions"
        [defaultOption]="'Select'"
        required
      >
      </app-input>
    </div>
    <div class="genderField">
      <app-input
        [type]="'dropdown'"
        name="gender"
        [(ngModel)]="userProfile.gender"
        (ngModelChange)="userProfileChange.emit(userProfile)"
        [formGroup]="userinfoAuthForm"
        label="Gender *"
        [placeholder]="'Gender'"
        [options]="genderOptions"
        [defaultOption]="'Select'"
        required
      >
      </app-input>
    </div>
  </div>
  <div class="demographicInfo">
    <div class="countryField">
      <app-input
        [type]="'dropdown'"
        name="country"
        [(ngModel)]="userProfile.country"
        (ngModelChange)="userProfileChange.emit(userProfile)"
        [formGroup]="userinfoAuthForm"
        label="Country *"
        [placeholder]="'Country'"
        [defaultOption]="'Select'"
        [options]="filterOptions"
        required
      >
      </app-input>
    </div>
    <div class="zipCodeField">
      <app-input
        [type]="'text'"
        name="zipCode"
        [(ngModel)]="userProfile.zipCode"
        (ngModelChange)="userProfileChange.emit(userProfile)"
        [formGroup]="userinfoAuthForm"
        label="Zip Code *"
        [placeholder]="'Zip Code'"
        pattern="^\d{5}$"
        required
      >
      </app-input>
    </div>
  </div>
  <div class="demographicInfo" *ngIf="!hidePhoneNumber">
    <div class="phone-field">
      <div class="phone">
          <app-input [type]="'text'" name="phone" [formGroup]="userinfoAuthForm" (input)="formatPhoneNumber($event)"
              label="Phone number *" [placeholder]="'Phone number'" [(ngModel)]="this.userProfile.phone"
              required
              (ngModelChange)="userProfileChange.emit(userProfile)"></app-input>
      </div>
    </div>
  </div>

  <app-marketing-info
    *ngIf="page !== 'signup' && showUserConsentCheckbox"
    [userProfile]="userProfile"
    [elementName]="elementName"
  ></app-marketing-info>
  <app-marketing-info  *ngIf="!hidePhoneNumber" [userProfile]="userProfile" [elementName]="'sms'"></app-marketing-info>
  <div class="terms-notice" *ngIf="showUserConsentCheckbox">
    <input
      type="checkbox"
      name="termsAgreement"
      class="opt-in-checkbox"
      [(ngModel)]="userProfile.termsAgreement"
      (ngModelChange)="userProfileChange.emit(userProfile)"
      required
    />
    <div class="terms-agreement-text terms-agreement-text-submit">
      Accept
      <span class="tnc-pp-span tertiary-button" (click)="onTermsClick(termsAndConditions)">
        Terms of Service
      </span>
      and
      <span class="tnc-pp-span tertiary-button" (click)="onTermsClick(privacyPolicy)"
        >Privacy Policy.</span
      >
    </div>
  </div>
  <app-form-navigation-buttons *ngIf="showFormNavigationBtn" [form]="userinfoAuthForm" [userProfile]="userProfile"></app-form-navigation-buttons>
</form>

